"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
const OrbitControls_js_1 = require("three/examples/jsm/controls/OrbitControls.js");
const GLTFLoader_1 = require("three/examples/jsm/loaders/GLTFLoader");
const gsap_1 = require("gsap");
const Fire_Shader_1 = require("./shaders/Fire.Shader");
const FoamParticles_Shader_1 = require("./shaders/FoamParticles.Shader");
const Warerfall_Shader_1 = require("./shaders/Warerfall.Shader");
const BottomFoam_Shader_1 = require("./shaders/BottomFoam.Shader");
const TopFoam_Shader_1 = require("./shaders/TopFoam.Shader");
const tweakpane_1 = require("tweakpane");
const FireFog_1 = require("./FireFog");
//
class FloatingRock {
    constructor() {
        this.elapsedTime = 0;
        this.sceneReady = false;
        this.foamPointCount = 200;
        this.outerColor = '#000000';
        this.innerColor = '#FFCE00';
        this.previousRenderScene = this.renderScene;
        this.sizes = {
            width: 0,
            height: 0
        };
        this.tick = () => {
            window.requestAnimationFrame(this.tick);
            // if ( this.renderScene !== this.previousRenderScene ) {
            //     this.previousRenderScene = this.renderScene;
            //     if ( this.fireplaceTwp ) {
            //         this.fireplaceTwp.hidden = !this.renderScene;
            //     }
            // }
            this.delta = this.clock.getDelta() * 1000;
            this.elapsedTime += this.delta;
            if (this.sizes.width !== window.innerWidth || this.sizes.height !== window.innerHeight) {
                this.resize();
            }
            if (this.flameMaterial) {
                this.flameMaterial.uniforms.uTime.value = this.elapsedTime / 3000;
            }
            this.waterfallMaterial.uniforms.uTime.value = this.elapsedTime / 1500;
            this.bottomFoamMaterial.uniforms.uTime.value = this.elapsedTime / 6000;
            this.topFoamMaterial.uniforms.uTime.value = this.elapsedTime / 6000;
            if (this.rightRock)
                this.rightRock.position.y -= Math.sin(this.elapsedTime / 700) / 4500 + Math.cos(this.elapsedTime / 700) / 4300;
            if (this.leftRock)
                this.leftRock.position.y -= Math.sin(this.elapsedTime / 980) / 4500 + Math.cos(this.elapsedTime / 930) / 3500;
            if (this.fog)
                this.fog.material.uniforms.uTime.value = this.elapsedTime;
            this.foamParticleMaterial.uniforms.uTime.value = Math.sin(this.elapsedTime / 500) * 0.005 + Math.cos(this.elapsedTime / 500) * 0.005;
            this.mapControls.update();
            this.renderer.render(this.scene, this.camera);
        };
    }
    init() {
        // Canvas
        this.canvas = document.querySelector('canvas.webglView');
        // Scene
        this.scene = new three_1.Scene();
        this.scene.background = new three_1.Color('#69deeb');
        // Sizes
        this.sizes.width = window.innerWidth,
            this.sizes.height = window.innerHeight;
        // Camera
        this.camera = new three_1.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 100);
        this.camera.position.set(1, 0.4, 1);
        this.scene.add(this.camera);
        // Light
        const light = new three_1.PointLight(0xffffff, 3, 10);
        light.position.set(3, 7, 3);
        this.scene.add(light);
        const ambientLight = new three_1.AmbientLight(0xffffff, 0.4);
        this.scene.add(ambientLight);
        // Controls
        this.mapControls = new OrbitControls_js_1.OrbitControls(this.camera, this.canvas);
        this.mapControls.enableZoom = false;
        // Renderer
        this.renderer = new three_1.WebGLRenderer({ canvas: this.canvas, antialias: true });
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        // Resize
        window.addEventListener('resize', this.resize());
        this.clock = new three_1.Clock();
        //
        // this.addFog();
        this.loadingBar();
        this.debug();
        this.loadModel();
        this.backgroundGradient();
        this.addWaterfall();
        this.addTopFoam();
        this.fireFlame();
        this.addBottomFoam();
        this.tick();
    }
    ;
    addFog() {
        // Fog
        let props = {
            numberOfSprites: 106,
            height: 0.001,
            width: 0.001,
            depth: 0.001,
            newPosition: new three_1.Vector3(-0.946, -0.37, 1.946)
        };
        this.fog = new FireFog_1.FireFogGfx(new three_1.Color().setHex(+this.outerColor.replace('#', '0x')).getHex(), props.numberOfSprites, props.height, props.width, props.depth);
        this.animation = new Animation();
        this.scene.add(this.fog.wrapper);
        props.newPosition = this.fog.newPosition;
    }
    ;
    debug() {
        let props = {
            color: '#fff30f',
            outerColor: '#ff0000',
            innerColor: '#FFCE00',
        };
        this.fireplaceTwp = new tweakpane_1.Pane({ title: "Fireplace", expanded: false });
        this.fireplaceTwp.element.parentElement.style['width'] = '330px';
        this.fireplaceTwp.element.parentElement.style['margin-top'] = '80px';
        this.fireplaceTwp.element.parentElement.style['z-index'] = '1000';
        this.fireplaceTwp.addInput(props, 'color', { label: 'inner color' }).on('change', () => {
            this.flameMaterial.uniforms.uInnerColor.value.setHex(parseInt(props.color.replace('#', '0x')));
        });
        this.fireplaceTwp.addInput(props, 'color', { label: 'outer color' }).on('change', () => {
            this.flameMaterial.uniforms.uOuterColor.value.setHex(parseInt(props.color.replace('#', '0x')));
        });
        this.fireplaceTwp.hidden = !this.renderScene;
    }
    ;
    //
    loadModel() {
        this.loader = new GLTFLoader_1.GLTFLoader(this.loadingManager);
        this.loader.load('resources/models/scene.gltf', (gltf) => {
            gltf.scene.children.forEach(element => {
                // gltf.scene.children[0] as Mesh;
                this.scene.add(element);
            });
        });
        //  middle rock
        this.loader = new GLTFLoader_1.GLTFLoader(this.loadingManager);
        this.loader.load('resources/models/stone1.gltf', (gltf) => {
            this.middleRock = gltf.scene.children[0];
            this.middleRock.scale.set(0.3, 0.3, 0.3);
            this.middleRock.rotation.z += Math.PI / 1;
            this.middleRock.position.set(0, -0.056, 0);
            this.scene.add(this.middleRock);
        });
        //  right rock
        this.loader = new GLTFLoader_1.GLTFLoader(this.loadingManager);
        this.loader.load('resources/models/stone3.gltf', (gltf) => {
            this.rightRock = gltf.scene.children[0];
            this.rightRock.scale.set(0.03, 0.03, 0.03);
            this.rightRock.rotation.z += Math.PI / 1;
            this.rightRock.rotation.x += Math.PI / 7;
            this.rightRock.rotation.y += Math.PI / 7;
            this.rightRock.position.set(0.5, -0.25, -0.120);
            this.scene.add(this.rightRock);
        });
        //  left rock
        this.loader.load('resources/models/stone2.gltf', (gltf) => {
            this.leftRock = gltf.scene.children[0];
            this.leftRock.scale.set(0.08, 0.08, 0.08);
            this.leftRock.rotation.z += Math.PI;
            this.leftRock.position.set(-0.55, 0.16, 0.35);
            this.scene.add(this.leftRock);
        });
        //
        this.loader.load('resources/models/house.gltf', (gltf) => {
            this.house = gltf.scene.children[0];
            this.house.scale.set(0.1, 0.07, 0.0002);
            // this.house.rotation.z += Math.PI / 3;
            // this.house.rotation.x -= Math.PI / 2;
            this.house.rotation.y = Math.PI / 2.3;
            this.house.position.set(-0.09, 0.1, 0.06);
            this.scene.add(this.house);
        });
        //
        this.loader.load('resources/models/treeNew.gltf', (gltf) => {
            let tree = gltf.scene.children[0];
            tree.scale.set(0.014, 0.014, 0.014);
            tree.position.set(0.17, 0.04, -0.02);
            this.scene.add(tree);
        });
        this.loader.load('resources/models/cloud.gltf', (gltf) => {
            this.cloud1 = gltf.scene.children[0];
            this.cloud1.scale.set(0.03, 0.03, 0.03);
            this.cloud1.rotation.y = Math.PI / 3.3;
            this.cloud1.position.set(0.2, 0.3, -0.2);
            this.scene.add(this.cloud1);
        });
        //
        this.loader.load('resources/models/cloud2.gltf', (gltf) => {
            this.cloud2 = gltf.scene.children[0];
            this.cloud2.scale.set(0.03, 0.03, 0.03);
            this.cloud2.rotation.y = Math.PI / 4;
            this.cloud2.position.set(-0.1, 0.35, 0.2);
            this.scene.add(this.cloud2);
        });
        // rocksOnMiddleRock.gltf
        this.loader.load('resources/models/rocksOnMiddleRock.gltf', (gltf) => {
            let rocksOnMiddleRock = gltf.scene.children[0];
            rocksOnMiddleRock.scale.set(0.65, 0.65, 0.65);
            rocksOnMiddleRock.rotation.y = Math.PI / 4;
            rocksOnMiddleRock.position.set(0.34, 0.0, 0.13);
            this.scene.add(rocksOnMiddleRock);
        });
    }
    ;
    backgroundGradient() {
        let planeGeometry = new three_1.PlaneGeometry(2, 2);
        let planeMaterial = new three_1.ShaderMaterial({
            depthWrite: false,
            vertexShader: `
                varying vec2 vUv;

                void main() {

                    gl_Position = vec4( position, 1.0 );

                    vUv = uv;

                }
            `,
            fragmentShader: `
                varying vec2 vUv;

                uniform vec3 uInnerColor;
                uniform vec3 uOuterColor;

                void main() {

                    vec2 centeredUv = vec2( vUv.x - 0.5, vUv.y - 0.35 );
                    float distance = length( centeredUv ) * 7.0;

                    vec3 color = mix( uInnerColor, uOuterColor, distance );

                    float yGradient = clamp( 0.5 - vUv.y, 0.0, 1.0 ) * 1.986;

                    color = mix( color, uOuterColor, yGradient );

                    gl_FragColor = vec4( color, 1.0 );

                }
            `,
            uniforms: {
                uInnerColor: { value: new three_1.Color(0xedf6f7) },
                uOuterColor: { value: new three_1.Color(0xb3eeff) }
            }
        });
        let backgroundPlane = new three_1.Mesh(planeGeometry, planeMaterial);
        this.scene.add(backgroundPlane);
    }
    ;
    fireFlame() {
        this.flameMaterial = new Fire_Shader_1.FlameMaterial();
        let flameGeometry = new three_1.PlaneGeometry(0.18, 0.23);
        let flame = new three_1.Mesh(flameGeometry, this.flameMaterial);
        flame.scale.set(0.66, 0.66, 0.66);
        flame.position.set(-0.946, -0.37, -0.946);
        this.scene.add(flame);
    }
    ;
    loadingBar() {
        const loadingBarElement = document.querySelector('.loading-bar');
        this.loadingManager = new three_1.LoadingManager(() => {
            window.setTimeout(() => {
                gsap_1.gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 });
                loadingBarElement.classList.add('ended');
                // @ts-ignore
                loadingBarElement.style.transform = '';
            }, 500);
            window.setTimeout(() => {
                this.sceneReady = true;
            }, 2000);
        }, (itemUrl, itemsLoaded, itemsTotal) => {
            const progressRatio = itemsLoaded / itemsTotal;
            // @ts-ignore
            loadingBarElement.style.transform = `scaleX(${progressRatio})`;
        });
        /**
         * Overlay
         */
        const overlayGeometry = new three_1.PlaneGeometry(2, 2, 1, 1);
        const overlayMaterial = new three_1.ShaderMaterial({
            // wireframe: true,
            transparent: true,
            uniforms: {
                uAlpha: { value: 1 }
            },
            vertexShader: `
                void main() {

                    gl_Position = vec4(position, 1.0);

                }
            `,
            fragmentShader: `
                uniform float uAlpha;

                void main() {

                    gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);

                }
            `
        });
        const overlay = new three_1.Mesh(overlayGeometry, overlayMaterial);
        this.scene.add(overlay);
    }
    ;
    resize() {
        this.sizes.width = window.innerWidth;
        this.sizes.height = window.innerHeight;
        this.camera.aspect = this.sizes.width / this.sizes.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }
    ;
    addWaterfall() {
        this.waterfallMaterial = new Warerfall_Shader_1.WaterfallMaterial();
        let waterfallGeometry = new three_1.PlaneGeometry(0.14, 0.327);
        let waterfall = new three_1.Mesh(waterfallGeometry, this.waterfallMaterial);
        let brightness = [];
        const transformRow1 = [];
        const transformRow2 = [];
        const transformRow3 = [];
        const transformRow4 = [];
        for (let i = 0; i < 50; i++) {
            brightness.push((Math.random() - 0.5) * 2);
            let rotationX = 0;
            let rotationY = Math.PI / 9;
            let rotationZ = 0;
            let transformMatrix = new three_1.Matrix4().compose(new three_1.Vector3(-0.1, 0, 0.05), new three_1.Quaternion().setFromEuler(new three_1.Euler(rotationX, rotationY, rotationZ)), new three_1.Vector3(1, 1, 1)).toArray();
            transformRow1.push(transformMatrix[0], transformMatrix[1], transformMatrix[2], transformMatrix[3]);
            transformRow2.push(transformMatrix[4], transformMatrix[5], transformMatrix[6], transformMatrix[7]);
            transformRow3.push(transformMatrix[8], transformMatrix[9], transformMatrix[10], transformMatrix[11]);
            transformRow4.push(transformMatrix[12], transformMatrix[13], transformMatrix[14], transformMatrix[15]);
        }
        waterfallGeometry.setAttribute('brightness', new three_1.Float32BufferAttribute(brightness, 1));
        waterfallGeometry.setAttribute('transformRow1', new three_1.Float32BufferAttribute(new Float32Array(transformRow1), 4));
        waterfallGeometry.setAttribute('transformRow2', new three_1.Float32BufferAttribute(new Float32Array(transformRow2), 4));
        waterfallGeometry.setAttribute('transformRow3', new three_1.Float32BufferAttribute(new Float32Array(transformRow3), 4));
        waterfallGeometry.setAttribute('transformRow4', new three_1.Float32BufferAttribute(new Float32Array(transformRow4), 4));
        this.scene.add(waterfall);
    }
    ;
    addBottomFoam() {
        this.bottomFoamMaterial = new BottomFoam_Shader_1.BottomFoamMaterial();
        let waterFoamGeometry = new three_1.PlaneGeometry(0.13, 0.2);
        let waterFoam = new three_1.Mesh(waterFoamGeometry, this.bottomFoamMaterial);
        let foamFade = [];
        const transformRow1 = [];
        const transformRow2 = [];
        const transformRow3 = [];
        const transformRow4 = [];
        for (let i = 0; i < 50; i++) {
            foamFade.push(1 - i * 0.02);
            let rotationX = 0;
            let rotationY = Math.PI / 9;
            let rotationZ = 0;
            let transformMatrix = new three_1.Matrix4().compose(new three_1.Vector3(-0.1, 0, 0.05), new three_1.Quaternion().setFromEuler(new three_1.Euler(rotationX, rotationY, rotationZ)), new three_1.Vector3(1, 1, 1)).toArray();
            transformRow1.push(transformMatrix[0], transformMatrix[1], transformMatrix[2], transformMatrix[3]);
            transformRow2.push(transformMatrix[4], transformMatrix[5], transformMatrix[6], transformMatrix[7]);
            transformRow3.push(transformMatrix[8], transformMatrix[9], transformMatrix[10], transformMatrix[11]);
            transformRow4.push(transformMatrix[12], transformMatrix[13], transformMatrix[14], transformMatrix[15]);
        }
        waterFoamGeometry.setAttribute('transformRow1', new three_1.Float32BufferAttribute(new Float32Array(transformRow1), 4));
        waterFoamGeometry.setAttribute('transformRow2', new three_1.Float32BufferAttribute(new Float32Array(transformRow2), 4));
        waterFoamGeometry.setAttribute('transformRow3', new three_1.Float32BufferAttribute(new Float32Array(transformRow3), 4));
        waterFoamGeometry.setAttribute('transformRow4', new three_1.Float32BufferAttribute(new Float32Array(transformRow4), 4));
        waterFoamGeometry.setAttribute('foamFade', new three_1.Float32BufferAttribute(foamFade, 1));
        this.scene.add(waterFoam);
        // Particle
        this.foamParticleMaterial = new FoamParticles_Shader_1.FoamParticle();
        this.foamParticleGeom = new three_1.BufferGeometry();
        this.foamPointPositions = new Float32Array(this.foamPointCount * 3);
        let foamSize = [];
        for (let i = 0; i < this.foamPointCount; i++) {
            this.foamPointPositions[i * 3] = (Math.random() - 0.5) * 0.05;
            this.foamPointPositions[i * 3 + 1] = (Math.random() - 0.5) * 0.03;
            this.foamPointPositions[i * 3 + 2] = (Math.random() - 0.5) * 0.01;
            if (Math.abs(this.foamPointPositions[i * 3 + 1]) > Math.random() * 0.005) {
                this.foamPointPositions[i * 3 + 1] = (Math.random() - 0.5) * 0.001;
            }
            foamSize.push(Math.random());
        }
        this.foamParticleGeom.setAttribute('position', new three_1.BufferAttribute(this.foamPointPositions, 3));
        this.foamParticleGeom.setAttribute('foamSize', new three_1.Float32BufferAttribute(foamSize, 1));
        let foamParticle = new three_1.Points(this.foamParticleGeom, this.foamParticleMaterial);
        foamParticle.position.x += 0.93;
        foamParticle.position.z += 0.93;
        foamParticle.position.y += 0.355;
        // this.scene.add( foamParticle );
    }
    ;
    addTopFoam() {
        let topFoamGeom = new three_1.PlaneGeometry(0.16, 0.33);
        this.topFoamMaterial = new TopFoam_Shader_1.TopmFoamShader();
        const transformRow1 = [];
        const transformRow2 = [];
        const transformRow3 = [];
        const transformRow4 = [];
        for (let i = 0; i < 50; i++) {
            let rotationX = 0;
            let rotationY = Math.PI / 9;
            let rotationZ = 0;
            let transformMatrix = new three_1.Matrix4().compose(new three_1.Vector3(-0.1, 0, 0.05), new three_1.Quaternion().setFromEuler(new three_1.Euler(rotationX, rotationY, rotationZ)), new three_1.Vector3(1, 1, 1)).toArray();
            transformRow1.push(transformMatrix[0], transformMatrix[1], transformMatrix[2], transformMatrix[3]);
            transformRow2.push(transformMatrix[4], transformMatrix[5], transformMatrix[6], transformMatrix[7]);
            transformRow3.push(transformMatrix[8], transformMatrix[9], transformMatrix[10], transformMatrix[11]);
            transformRow4.push(transformMatrix[12], transformMatrix[13], transformMatrix[14], transformMatrix[15]);
        }
        topFoamGeom.setAttribute('transformRow1', new three_1.Float32BufferAttribute(new Float32Array(transformRow1), 4));
        topFoamGeom.setAttribute('transformRow2', new three_1.Float32BufferAttribute(new Float32Array(transformRow2), 4));
        topFoamGeom.setAttribute('transformRow3', new three_1.Float32BufferAttribute(new Float32Array(transformRow3), 4));
        topFoamGeom.setAttribute('transformRow4', new three_1.Float32BufferAttribute(new Float32Array(transformRow4), 4));
        let topFoam = new three_1.Mesh(topFoamGeom, this.topFoamMaterial);
        this.scene.add(topFoam);
    }
    ;
}
exports.default = FloatingRock;
;
